import { Link } from "react-router-dom";
import { Phone, ClipboardList } from "lucide-react";
import { ATTORNEY } from "@/data/content";

const digits = (ATTORNEY.phone || "").replace(/[^0-9]/g, "");
const tel = `tel:${digits}`;

/**
 * Sticky Call Now action.
 * - Mobile (< lg): full-width fixed bottom bar.
 * - Desktop (>= lg): floating pill in the bottom-right corner.
 */
export default function StickyContact() {
    return (
        <>
            {/* MOBILE — bottom action bar */}
            <div
                data-testid="sticky-contact-mobile"
                className="lg:hidden fixed bottom-0 inset-x-0 z-[60] grid grid-cols-2 border-t border-[#1F3458] bg-[#07142B]/95 backdrop-blur-md"
                style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            >
                <Link
                    to="/case-evaluator"
                    data-testid="sticky-eval-mobile"
                    className="flex items-center justify-center gap-2 py-4 text-[#D4AF37] font-bold uppercase tracking-wider text-xs border-r border-[#1F3458] active:bg-[#11203D]"
                >
                    <ClipboardList size={15} />
                    60-Sec Evaluator
                </Link>
                <a
                    href={tel}
                    data-testid="sticky-call-mobile"
                    className="flex items-center justify-center gap-2 py-4 bg-[#D4AF37] text-[#07142B] font-bold uppercase tracking-wider text-xs active:bg-[#B8962A]"
                >
                    <Phone size={15} />
                    Call Now
                </a>
            </div>

            {/* DESKTOP — floating pills */}
            <div
                data-testid="sticky-contact-desktop"
                className="hidden lg:flex fixed bottom-6 right-6 z-[60] items-center gap-3"
            >
                <Link
                    to="/case-evaluator"
                    data-testid="sticky-eval-desktop"
                    className="flex items-center gap-2 border border-[#D4AF37] bg-[#07142B]/95 backdrop-blur-md text-[#D4AF37] font-bold uppercase tracking-wider text-xs px-5 py-4 rounded-full shadow-lg shadow-black/40 hover:bg-[#D4AF37] hover:text-[#07142B] transition-colors"
                >
                    <ClipboardList size={15} />
                    <span>60-Sec Evaluator</span>
                </Link>
                <a
                    href={tel}
                    data-testid="sticky-call-desktop"
                    className="group flex items-center gap-3 bg-[#D4AF37] text-[#07142B] font-bold uppercase tracking-wider text-xs pl-5 pr-6 py-4 rounded-full shadow-lg shadow-black/40 hover:bg-[#B8962A] transition-colors"
                >
                    <Phone size={16} />
                    <span>Call {ATTORNEY.phone}</span>
                </a>
            </div>
        </>
    );
}
